import React, {useEffect, useState} from 'react';
import NoteTitle from '../NoteTitle/NoteTitle';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';

const songSetupSuccess = (props) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    switch (props.type) {
      case 'defaultSong':
        setContent('השיר יושמע לכל מי שיתקשר אליך פרט לאנשי הקשר שהוגדר להם שיר ייעודי');
        break;
      case 'contacts':
        setContent('השיר יושמע לאנשי הקשר  שבחרת');
        break;
      case 'storage':
        setContent(`השיר נשמר במאגר השירים שלכם. תוכלו להגדירו מהמחשב בכל זמן שתרצו באזור האישי באתר ${window.Config.brand_Name_HE}`);
        break;
      default:
        break;
    }
  }, [props.type]);

  return (
    <section className='songSetupSuccess'>
      <NoteTitle text='השיר הוגדר בהצלחה' />
      <p className='text'>{content}</p>
      <BtnWhite onclick={() => props.onClickBtn()} text="סיום" formid="song-setup-success-page"></BtnWhite>
    </section>
  );
};

export default songSetupSuccess;
